export default function Hero() {
  return (
    <section className="relative min-h-[80vh] lg:min-h-0 flex items-center justify-center overflow-hidden bg-gradient-to-br from-lime-50 via-green-50 to-yellow-50">
      <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-white/40"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-4 md:left-10 w-20 md:w-32 h-20 md:h-32 bg-lime-400/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-4 md:right-10 w-24 md:w-40 h-24 md:h-40 bg-yellow-400/20 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/4 w-16 md:w-24 h-16 md:h-24 bg-green-400/20 rounded-full blur-2xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-24 lg:py-20 text-center">
        <div className="mb-6 md:mb-8 inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-sm">
          <span className="w-2 h-2 bg-lime-500 rounded-full animate-pulse"></span>
          <span className="text-xs sm:text-sm font-medium text-gray-700">Financial Mindfulness for the Latino/a/e Community</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
          Achieve Financial<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-lime-500 via-green-500 to-yellow-500">
            Happiness & Security
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-8 sm:mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed px-2">
          We remove the complex process of managing finances by automatically generating personalized&nbsp;plans, and coaching&nbsp;through every financial decision.
        </p>

        <button 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const formCard = document.getElementById('waitlist-form-card');
            const nameInput = document.getElementById('name');
            
            if (formCard) {
              const isMobile = window.innerWidth < 768;
              formCard.scrollIntoView({
                behavior: 'smooth',
                block: isMobile ? 'start' : 'center'
              });
              
              setTimeout(() => {
                if (nameInput) {
                  (nameInput as HTMLInputElement).focus();
                }
              }, isMobile ? 1000 : 800);
            }
          }}
          className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-lime-500 text-white text-base sm:text-lg font-semibold rounded-full hover:bg-lime-600 transition-all hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Join the Waitlist
          <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
        </button>

        <div className="mt-10 sm:mt-12 md:mt-16 flex flex-col items-start sm:flex-row sm:flex-wrap sm:justify-center sm:items-center gap-4 sm:gap-8 lg:gap-12 text-gray-500 mx-auto w-fit sm:w-auto">
          <div className="flex items-center gap-3">
            <i className="ri-heart-line text-lime-500 text-2xl sm:text-3xl"></i>
            <span className="text-base sm:text-lg font-medium">Finance w/ Care</span>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-robot-2-line text-lime-500 text-2xl sm:text-3xl"></i>
            <span className="text-base sm:text-lg font-medium">Advanced Tech</span>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-shield-check-line text-lime-500 text-2xl sm:text-3xl"></i>
            <span className="text-base sm:text-lg font-medium">Secure &amp; Private</span>
          </div>
        </div>
      </div>
    </section>
  );
}
